import React, { Component } from "react";
import axios from "axios";
import { Table, Tag } from "antd";

//Desglose de la existencia apartada de un insumo dentro de un almacén: de qué pedido,
//venta o envío viene cada parte del apartado. Se usa en el panel expandible de
//Inventario.js, solo en las líneas con estado 2 (Apartado).
const COLORES_TIPO = {
  Pedido: "blue",
  Venta: "red",
  "Envío": "orange",
};

class DesgloseApartadoInsumo extends Component {
  state = {
    loading: false,
    apartados: [],
    total: 0,
  };

  componentDidMount() {
    this.cargarDesglose();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.insumoId !== this.props.insumoId ||
      prevProps.proyectoId !== this.props.proyectoId ||
      prevProps.refreshKey !== this.props.refreshKey
    ) {
      this.cargarDesglose();
    }
  }

  async cargarDesglose() {
    if (!this.props.insumoId || !this.props.proyectoId) return;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "inventarios/desgloseApartadoInsumo",
        {
          empresaId: this.props.empresaId,
          proyectoId: this.props.proyectoId,
          insumoId: this.props.insumoId,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.setState({
          apartados: res.data.apartados || [],
          total: res.data.total || 0,
        });
      }
    } catch (error) {
      console.error("Error al cargar el desglose de apartados:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  irAlDocumento(record) {
    if (!this.props.history || !record.documentoId) return;
    if (record.tipo === "Pedido") {
      this.props.history.push("/panel/verPedido", { id: record.documentoId });
    } else if (record.tipo === "Venta") {
      this.props.history.push("/panel/verVenta", { id: record.documentoId });
    }
  }

  render() {
    const columns = [
      {
        title: "Documento",
        key: "documento",
        render: (_, record) => (
          <span>
            <Tag color={COLORES_TIPO[record.tipo] || "default"} className="square-tag">
              {record.tipo}
            </Tag>
            {record.folio ? <strong>{record.folio}</strong> : null}
          </span>
        ),
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        render: (value) => value || "-",
      },
      {
        title: "Cantidad Apartada",
        dataIndex: "cantidad",
        key: "cantidad",
        align: "right",
        render: (value) => Number(value || 0).toFixed(4),
      },
    ];

    return (
      <div style={{ padding: "8px 24px", background: "#fafafa" }}>
        <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 6 }}>
          Apartado por documento — doble clic en un pedido o una venta para abrirlo
        </div>
        <Table
          size="small"
          rowKey={(record, index) => `${record.tipo}-${record.documentoId || index}`}
          dataSource={this.state.apartados}
          columns={columns}
          pagination={false}
          loading={this.state.loading}
          locale={{ emptyText: "No se encontraron documentos que expliquen este apartado" }}
          onRow={(record) => ({
            onDoubleClick: () => this.irAlDocumento(record),
          })}
          summary={() =>
            this.state.apartados.length > 0 ? (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={2}>
                  <strong>Total apartado</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="right">
                  <strong>{Number(this.state.total || 0).toFixed(4)}</strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            ) : null
          }
        />
      </div>
    );
  }
}

export default DesgloseApartadoInsumo;
